export default __webpack_public_path__ + "static/media/018-cucumber.e9a40c9d.svg";